import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getCatalogStructure } from '../api';

function GradeLevelsPage() {
  const navigate = useNavigate();
  const { stateName } = useParams();
  const decodedState = decodeURIComponent(stateName || '');
  const [catalog, setCatalog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getCatalogStructure()
      .then((data) => {
        if (!cancelled) {
          setCatalog(data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || 'Failed to load catalog');
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, []);

  const selectedState = useMemo(() => {
    if (!catalog) return null;
    return (catalog.states || []).find((state) => state.name === decodedState) || null;
  }, [catalog, decodedState]);

  const gradeLevels = selectedState?.gradeLevels || [];

  return (
    <div className="browse-page-container">
      <button
        type="button"
        className="back-button"
        onClick={() => navigate('/')}
      >
        ← Back to Home
      </button>

      <div className="browse-page-header">
        <h1 className="browse-page-title">{decodedState || 'Choose your grade'}</h1>
        <p className="browse-page-subtitle">
          Pick a grade to see its learning path.
        </p>
      </div>

      {loading && (
        <div className="browse-loading">
          <div className="browse-loading-spinner" />
          <span>Loading grade levels…</span>
        </div>
      )}

      {error && <div className="error">{error}</div>}

      {!loading && !error && !selectedState && (
        <div className="browse-empty">No state named “{decodedState}” was found.</div>
      )}

      {!loading && !error && selectedState && gradeLevels.length === 0 && (
        <div className="browse-empty">No grade levels found.</div>
      )}

      {!loading && !error && selectedState && (
        <div className="grade-level-cards-grid">
          {gradeLevels.map((gl) => {
            const majorTopicCount = (gl.majorTopics || []).length;
            const topicCount = (gl.topics || []).length;
            const count = majorTopicCount || topicCount;
            const label = 'learning path';

            return (
              <button
                key={gl.name}
                type="button"
                className="grade-level-card"
                onClick={() => navigate(
                  `/state/${encodeURIComponent(decodedState)}/grade/${encodeURIComponent(gl.name)}`
                )}
              >
                <span className="grade-level-card-name">{gl.name}</span>
                <span className="grade-level-card-count">
                  {count} {label}{count !== 1 ? 's' : ''}
                </span>
                <span className="grade-level-card-arrow">→</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default GradeLevelsPage;
